export default __webpack_public_path__ + "static/media/list_view_icon_active.6b92b3bb.svg";